import { h, JSX, FunctionalComponent } from "preact";
import { Icon } from "@uw/icons/types";
const defaultStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
};
const SvgIcon = (props: JSX.SVGAttributes<any>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 16" {...props}>
    <g
      fill="none"
      fill-rule="evenodd"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-width={1.84}
    >
      <path d="M16.201 8c0 .967-.19 1.887-.532 2.725a7.029 7.029 0 0 1-1.452 2.225 6.778 6.778 0 0 1-2.153 1.5 6.573 6.573 0 0 1-2.637.55 6.569 6.569 0 0 1-2.638-.55 6.778 6.778 0 0 1-2.153-1.5M2.652 8c0-.967.19-1.887.533-2.725A7.029 7.029 0 0 1 4.636 3.05a6.778 6.778 0 0 1 2.153-1.5A6.569 6.569 0 0 1 9.427 1c.935 0 1.826.196 2.637.55.81.354 1.54.867 2.153 1.5" />
      <path
        stroke-linejoin="round"
        d="m4.926 6.961-2.49 1.484L1 5.872m13.013 2.939 2.388-1.652L18 9.627"
      />
    </g>
  </svg>
);
export const ReloadIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: "100%",
    height: "100%",
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => (
  <span
    className={className}
    style={{
      ...defaultStyle,
      ...styles,
    }}
  >
    <SvgIcon {...svgAttrs} />
  </span>
);
